<template>
    <img class="animating-heart" :src="imageUrl('like_fill.svg')"/>
</template>

<script>

    import Mixins from '../../mixins/mixins';

    export default{
        mixins: [Mixins]
    }

</script>